import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  onOpenBooking: () => void;
}
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.3
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Hero({
  onOpenBooking
}: HeroProps) {
  const scrollToServices = () => {
    const el = document.querySelector('#services');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-172">
      {/* Background mood image — night jacuzzi */}
      <div className="absolute inset-0" data-id="element-173">
        <img src="https://cdn.magicpatterns.com/uploads/xk1BUKjQbkpYLMKFVDjgJF/ZenB-18.jpg" alt="" className="w-full h-full object-cover" data-id="element-174" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(139,100,72,0.6) 0%, rgba(139,100,72,0.55) 40%, rgba(100,72,52,0.6) 70%, rgba(61,50,41,0.75) 100%)'
      }} data-id="element-175" />
      </div>

      {/* Subtle decorative elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true" data-id="element-176">
        <div className="absolute top-[15%] left-[10%] w-64 h-64 rounded-full opacity-[0.05]" style={{
        background: 'radial-gradient(circle, #D4DDD0, transparent 70%)'
      }} data-id="element-177" />
        <div className="absolute bottom-[20%] right-[8%] w-80 h-80 rounded-full opacity-[0.04]" style={{
        background: 'radial-gradient(circle, #F5EDE4, transparent 70%)'
      }} data-id="element-178" />
        <svg className="absolute bottom-32 left-1/2 -translate-x-1/2 w-48 opacity-[0.15]" viewBox="0 0 200 40" fill="none" data-id="element-179">
          <line x1="0" y1="20" x2="80" y2="20" stroke="#D4DDD0" strokeWidth="0.8" data-id="element-180" />
          <circle cx="100" cy="20" r="8" stroke="#D4DDD0" strokeWidth="0.8" fill="none" data-id="element-181" />
          <line x1="120" y1="20" x2="200" y2="20" stroke="#D4DDD0" strokeWidth="0.8" data-id="element-182" />
        </svg>
      </div>

      <motion.div className="relative z-10 text-center px-6 max-w-3xl mx-auto" variants={container} initial="hidden" animate="show" data-id="element-183">
        <motion.p variants={fadeUp} className="text-sm font-body font-medium tracking-[0.3em] uppercase text-cream/70 mb-6" data-id="element-184">
          Richiș · Transylvania
        </motion.p>

        <motion.h1 variants={fadeUp} className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-semibold text-cream leading-[1.1] tracking-wide mb-6" data-id="element-185">
          Zen Barn Spa
        </motion.h1>

        <motion.p variants={fadeUp} className="font-heading text-xl sm:text-2xl md:text-3xl font-normal italic text-cream/80 mb-8 leading-relaxed" data-id="element-186">
          An oasis in the heart of Transylvania
        </motion.p>

        <motion.p variants={fadeUp} className="font-body text-base md:text-lg text-cream/70 max-w-xl mx-auto mb-12 leading-relaxed" data-id="element-187">
          Nestled in the Saxon village of Richiș, where centuries of heritage
          meet modern wellness.
        </motion.p>

        <motion.div variants={fadeUp} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-188">
          <button onClick={scrollToServices} className="inline-flex items-center px-8 py-4 border-2 border-cream/40 text-cream font-body font-medium text-sm tracking-wide rounded-full hover:bg-cream/10 transition-colors duration-300 focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2" data-id="element-189">
            Discover Our Retreat
          </button>
          <button onClick={onOpenBooking} className="inline-flex items-center px-8 py-4 bg-terracotta text-white font-body font-medium text-sm tracking-wide rounded-full hover:bg-terracotta-dark transition-colors duration-300 focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2" data-id="element-190">
            Book a Session
          </button>
        </motion.div>
      </motion.div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.8,
      duration: 0.8
    }} aria-hidden="true" data-id="element-191">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="w-5 h-8 rounded-full border-2 border-cream/30 flex items-start justify-center p-1" data-id="element-192">
          <div className="w-1 h-2 rounded-full bg-cream/40" data-id="element-193" />
        </motion.div>
      </motion.div>
    </section>;
}